"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InvestmentOption = (function () {
    function InvestmentOption() {
        this.name = null;
        this.grossReturn = 0;
        this.taxableFraction = 0;
        this.feePercentageOnBalance = 0;
        this.feePercentageOnBalanceCapped = 0;
        this.feePercentageOnBalanceCappedCap = 0;
        this.feePercentageOnContributions = 0;
        this.feeAnnualDollar = 0;
    }
    return InvestmentOption;
}());
exports.InvestmentOption = InvestmentOption;
//# sourceMappingURL=InvestmentOption.js.map